import { useParams } from 'react-router-dom';
import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { IrpCreateEditProvider } from './context/irp-create-edit-context';
import { IrpCreateEditComponent } from './irp-create-edit-component';

export function IrpCreateEditFactory() {
    // A chave reinicia o estado quando a rota passa de inclusão para edição após salvar
    const { irpId } = useParams();

    return (
        <BaseLayoutFactory>
            <IrpCreateEditProvider key={irpId ?? 'new'}>
                <IrpCreateEditComponent />
            </IrpCreateEditProvider>
        </BaseLayoutFactory>
    );
}
